import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div<{ $centered?: boolean; $minHeight?: string }>`
  display: ${({ $centered }) => ($centered ? 'grid' : 'block')};
  place-items: ${({ $centered }) => ($centered ? 'center' : 'initial')};
  min-height: ${({ $minHeight }) => $minHeight || '240px'};
`;

const Loader = styled.div<{ $size?: 'small' | 'medium' | 'large' }>`
  width: ${({ $size }) => ($size === 'small' ? '24px' : $size === 'large' ? '48px' : '36px')};
  height: ${({ $size }) => ($size === 'small' ? '24px' : $size === 'large' ? '48px' : '36px')};
  border: ${({ $size }) => ($size === 'small' ? '2px' : $size === 'large' ? '4px' : '3px')} solid rgba(0, 0, 0, 0.08);
  border-top: ${({ $size }) => ($size === 'small' ? '2px' : $size === 'large' ? '4px' : '3px')} solid rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  minHeight?: string;
  centered?: boolean;
}

export function LoadingSpinner({
  size = 'medium',
  minHeight = '240px',
  centered = true,
}: LoadingSpinnerProps) {
  return (
    <Container $centered={centered} $minHeight={minHeight}>
      <Loader $size={size} />
    </Container>
  );
}
